import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { SYSTEM_TIME_ZONE_LABEL } from '@/lib/system-time-zone-datetime';

interface SystemTimeZoneDateTimeFieldProps {
    readonly id: string;
    readonly label: string;
    /** A datetime-local value in the system display time zone. */
    readonly value: string;
    readonly onChange: (value: string) => void;
}

/** A date and time input whose label names the zone the value is entered in. */
export function SystemTimeZoneDateTimeField({
    id,
    label,
    value,
    onChange,
}: SystemTimeZoneDateTimeFieldProps) {
    const zonedLabel = `${label} (${SYSTEM_TIME_ZONE_LABEL})`;
    return (
        <div className="space-y-2">
            <Label htmlFor={id}>{zonedLabel}</Label>
            <Input
                id={id}
                aria-label={zonedLabel}
                type="datetime-local"
                value={value}
                onChange={(event) => onChange(event.target.value)}
            />
        </div>
    );
}
